module.exports = __webpack_public_path__ + "img/shopping.d578a8f5.svg";